import axios from "axios";
import NProgress from "nprogress";


const apiClient = axios.create({
  baseUrl: "http://localhost:3000",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

//const url = "http://wohnungsdatenbank.wuerfelserver.de/backend/Angebote/";
const url = "https://www.wohnungsdatenbank.uni-freiburg.de/backend/Angebote/";



export default {
  getAngebote() {
    return apiClient.get(url + "angebote.php");
  },
  getAngeboteAbgelehnt() {
    return apiClient.get(url + "angeboteAbgelehnt.php");
  },
  getAngeboteAktiv() {
    return apiClient.get(url + "angeboteAktiv.php");
  },
  getAngeboteBearbeitung() {
    return apiClient.get(url + "angeboteZurBearbeitung.php");
  },
  getAngeboteFreigegeben() {
    return apiClient.get(url + "angeboteFreigegeben.php");
  },
  getAngeboteInaktiv() {
    return apiClient.get(url + "angeboteInaktiv.php");
  },
  getAngeboteSelf(id) {
    return apiClient.get(url + "angeboteSelf.php",{
      params:{
        userid: id,
      }
    });
  },
  deleteAngebotSelf(id) {
    return apiClient.get(url + "deleteSelf.php",{
      params:{
        id: id,
      }
    });
  },
  getAngeboteSelfBearbeitung(id) {
    return apiClient.get(url + "angeboteSelfBearbeitung.php",{
      params:{
        userid: id,
      }
    });
  },
  getAngebot(id) {
    return apiClient.get(url + "angebote.php", {
      /*params: {
        userid: id
      }*/
    });
  },
  getAngeboteByStatus(s, sv){
    return apiClient.get(url + "getAngebotStatus.php", {
      params: {
        status: s,
        statusValue: sv
      }
    });
  },
  setAngebotStatus(a, s, sv,k){
    if(k){
      return apiClient.get(url + "setAngebotStatus.php", {
        params: {
          angebot: a,
          status: s,
          statusValue: sv,
          kommentar: k
        }
      });
    } else {
      return apiClient.get(url + "setAngebotStatus.php", {
        params: {
          angebot: a,
          status: s,
          statusValue: sv,
        }
      });
    }


  },
  editAngebot(a){
    console.log(a);
    return apiClient.get(url + "editAngebot.php", {
      params: {
        angebot: JSON.stringify(a),
      }
    });

  },
  addAngebotToMerkliste(a, u){
    let toReturn =  apiClient.get(url + "angebotToMerkliste.php", {
      params: {
        angebotid: a,
        user: u,
      }
    });
    return toReturn

  },
  isAngebotOnMerkliste(a, u, t){
    return apiClient.get(url + "isAngebotOnMerkliste.php", {
      params: {
        angebot: a,
        user: u,
        userType: t,
      }
    });

  },
  getMerkliste(u){
    return apiClient.get(url + "getMerkliste.php", {
      params: {
        user: u,
      }
    });

  },
  removeMerkliste(a, u){
    return apiClient.get(url + "removeMerkliste.php", {
      params: {
        angebot: a,
        user: u
      }
    });
  },
  addImages(images){
    console.log(images)
    return apiClient.get(url + "handleImages.php", {
      params: {
        images: images
      },
      headers: {'Content-Type': 'multipart/form-data' }
    });
  },
  addAngebote(angebot, vermieter) {
    return apiClient.get(url + "angebotCreate.php",{
      params: {
        vermieter: vermieter,
        zimmerart: angebot.art,
        ausstattungbad: angebot.ausstattungbad,
        ausstattungkueche: angebot.ausstattungkueche,
        ausstattungsonstiges: angebot.ausstattungsonstiges,
        ausstattungsonstigesinternet: angebot.ausstattungsonstigesinternet,
        ausstattungsonstigestelefon: angebot.ausstattungssonstigestelefon,
        email: angebot.email,
        etage: angebot.etage,
        freiab: angebot.freiab,
        freibis: angebot.freibis,
        mietergeschlecht: angebot.mietergeschlecht,
        hausnummer: angebot.hausnummer,
        kaution: angebot.kaution,
        miete: angebot.miete,
        mieterbevorzugt: angebot.mieterbevorzugt,
        mieterhandikap: angebot.mieterhandikap,
        mieterraucher: angebot.mieterraucher,
        minimalemietdauer: angebot.minimalemietdauer,
        name: angebot.name,
        nebenkosten: angebot.nebenkosten,
        nebenkostenart: angebot.nebenkostenArt,
        telefon: angebot.telefon,
        mobil: angebot.mobil,
        ort: angebot.ort,
        plz: angebot.plz,
        showemail: angebot.showemail,
        showmobil: angebot.showmobil,
        showname: angebot.showname,
        showtelefon: angebot.showtelefon,
        stadtteil: angebot.stadtteil,
        strasse: angebot.strasse,
        userid: angebot.userid,
        verkehrsanbindung: angebot.verkehrsanbindung,
        zimmergroesse: angebot.zimmergroesse,
        zimmerzusatzinformationen: angebot.zimmerzusatzinformationen,
        entfernung: angebot.entfernung,
        bemerkung: angebot.bemerkung,
        lift: angebot.lift,
        stockwerk: angebot.stockwerk,
        abgelehnt: angebot.abgelehnt

      }
    });
  }
};
